/* Thema 2, koopzone (29-09-2026). Bovenop theme.js en product-v2.js, geladen met defer vanuit
   sections/main-product.liquid. Drie taken, allemaal progressive enhancement:

   1. Kleur als fotorij: kiest de klant een kleur waarin haar maat niet bestaat, dan springt de maat naar de eerste
      maat die in die kleur wel te koop is (dezelfde regel als het vroegere kleurvenster), zodat ze nooit op
      "niet beschikbaar" uitkomt.
   2. De regel Op voorraad verdwijnt bij een variant die niet te koop is.
   3. De aantalkeuze met stapelkorting (snippets/bundle-ladder.liquid): per extra stuk een rij met kleur en maat, de
      prijs met korting zoals Shopify hem rekent (per stuk naar beneden afgerond: twee jassen van 599,95 kr geven
      119,98 kr korting, gecontroleerd in een echte winkelwagen), en bij toevoegen alle stuks in één keer via het
      gewone formulier (items[][id] en items[][quantity]); theme.js doet de rest (winkelwagenlade).

   Zonder dit script werkt de pagina gewoon met één stuk. */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var T = window.theme || {};

  /* Same money formatting as theme.js, so the ladder prints amounts exactly like the price above it. */
  function money(cents) {
    var format = T.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var decimals = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var thousands = ',';
    var decimal = '.';
    if (key.indexOf('comma_separator') > -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') > -1) { thousands = ' '; decimal = ','; }
    if (key.indexOf('apostrophe_separator') > -1) { thousands = "'"; decimal = '.'; }
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return format.replace(/\{\{\s*\w+\s*\}\}/, parts.join(decimal));
  }
  function fill(text, values) {
    return String(text || '').replace(/%(\w+)%/g, function (match, name) {
      return Object.prototype.hasOwnProperty.call(values, name) ? values[name] : match;
    });
  }

  $$('[data-product]').forEach(function (root) {
    var variants = [];
    try { variants = JSON.parse($('script[data-variants]', root).textContent); } catch (err) { return; }
    var colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    var form = $('form[data-product-form]', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var button = form ? $('[data-add-button]', form) : null;
    var buttonLabel = button ? $('.btn__label', button) : null;
    var stockLine = $('[data-stock-line]', root);
    var textAdd = root.getAttribute('data-text-add') || '';
    var textSoldOut = root.getAttribute('data-text-sold-out') || '';

    function checked() {
      var out = [];
      $$('[data-option-index]:checked', root).forEach(function (input) {
        out[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return out;
    }
    function matches(v, opts) {
      for (var j = 0; j < opts.length; j++) { if (opts[j] !== undefined && v.o[j] !== opts[j]) return false; }
      return true;
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) { if (matches(variants[i], opts)) return variants[i]; }
      return null;
    }
    function anyAvailable(opts) {
      return variants.some(function (v) { return v.a && matches(v, opts); });
    }

    /* ---- 1. kleur zonder de gekozen maat: naar een maat die er wel is ---------------------------- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!(colorIndex >= 0) || !t || !t.matches || !t.matches('input[data-option-index="' + colorIndex + '"]')) return;
      var opts = checked();
      if (anyAvailable(opts)) return;
      $$('.option__values', root).forEach(function (group) {
        var inputs = $$('input[type="radio"][data-option-index]', group);
        if (!inputs.length || anyAvailable(opts)) return;
        var idx = parseInt(inputs[0].getAttribute('data-option-index'), 10);
        if (idx === colorIndex) return;
        for (var i = 0; i < inputs.length; i++) {
          var test = opts.slice();
          test[idx] = inputs[i].value;
          if (!anyAvailable(test)) continue;
          inputs[i].checked = true;
          opts = test;
          inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      });
    });

    /* ---- 2. Op voorraad alleen bij een variant die te koop is ------------------------------------- */
    function syncStock() {
      if (!stockLine) return;
      var v = find(checked());
      stockLine.hidden = !(v && v.a);
    }
    root.addEventListener('change', syncStock);
    syncStock();

    /* ---- 3. aantalkeuze met stapelkorting -------------------------------------------------------- */
    var ladder = $('[data-ladder]', root);
    if (!ladder || !form || !idInput) return;
    var cfg;
    try { cfg = JSON.parse($('script[data-ladder-config]', ladder).textContent); } catch (err) { return; }
    var decoder = document.createElement('textarea');
    Object.keys(cfg.strings || {}).forEach(function (k) { decoder.innerHTML = cfg.strings[k]; cfg.strings[k] = decoder.value; });
    var steps = $$('[data-qty]', ladder);
    var rowsEl = $('[data-ladder-rows]', ladder);
    var sumEl = $('[data-ladder-sum]', ladder);
    var teaser = $('[data-ladder-teaser]', ladder);
    var tpl = $('template[data-ladder-row]', ladder);
    var sizeIndex = parseInt(ladder.getAttribute('data-size-index'), 10);
    var qty = 1;
    var lastQty = 1;

    function pctFor(n) {
      var p = 0;
      (cfg.tiers || []).forEach(function (t) { if (n >= t.min) p = t.percent; });
      return p;
    }
    function thumbFor(v) {
      if (!v || !v.m) return null;
      var img = root.querySelector('[data-thumb-for="' + v.m + '"] img');
      return img ? (img.currentSrc || img.src) : null;
    }
    function rowOptions(row) {
      var opts = checked().slice();
      $$('select[data-row-option]', row).forEach(function (s) { opts[parseInt(s.getAttribute('data-row-option'), 10)] = s.value; });
      return opts;
    }
    function rowVariant(row) { return find(rowOptions(row)); }
    function markRow(row) {
      var colourSel = row.querySelector('select[data-row-option="' + colorIndex + '"]');
      var sizeSel = row.querySelector('select[data-row-option="' + sizeIndex + '"]');
      var base = checked().slice();
      if (colourSel) base[colorIndex] = colourSel.value;
      if (sizeSel) {
        Array.prototype.forEach.call(sizeSel.options, function (o) {
          var test = base.slice();
          test[sizeIndex] = o.value;
          o.disabled = !anyAvailable(test);
        });
        var current = sizeSel.options[sizeSel.selectedIndex];
        if (current && current.disabled) {
          for (var i = 0; i < sizeSel.options.length; i++) { if (!sizeSel.options[i].disabled) { sizeSel.selectedIndex = i; break; } }
        }
      }
      var v = rowVariant(row);
      var img = row.querySelector('[data-row-thumb]');
      var src = thumbFor(v) || thumbFor(find(checked()));
      if (img && src) img.src = src;
      row.classList.toggle('is-out', !(v && v.a));
    }
    function buildRows() {
      var have = $$('.ladder__row', rowsEl);
      while (have.length > qty - 1) rowsEl.removeChild(have.pop());
      var cur = checked();
      for (var n = have.length + 2; n <= qty; n++) {
        var row = tpl.content.firstElementChild.cloneNode(true);
        row.querySelector('[data-row-num]').textContent = n;
        $$('select[data-row-option]', row).forEach(function (s) {
          var idx = parseInt(s.getAttribute('data-row-option'), 10);
          if (cur[idx] !== undefined) s.value = cur[idx];
          var lab = row.querySelector('[data-row-label="' + (idx === colorIndex ? 'colour' : 'size') + '"]');
          s.setAttribute('aria-label', fill(cfg.strings.item, { n: n }) + (lab ? ': ' + lab.textContent.trim() : ''));
        });
        rowsEl.appendChild(row);
        markRow(row);
      }
    }
    /* The discount per stuk, rounded down to the øre/cent, as Shopify allocates a percentage discount: two coats of
       599,95 kr at 10% give 119,98 kr off, not 119,99 (checked in a real cart on 29-09-2026). */
    function priced(items, pct) {
      var full = 0;
      var off = 0;
      items.forEach(function (v) {
        if (!v) return;
        full += v.p;
        off += Math.floor(v.p * pct / 100);
      });
      return { full: full, total: full - off, off: off };
    }
    function update() {
      var main = find(checked());
      var items = [main].concat($$('.ladder__row', rowsEl).map(rowVariant));
      var ok = items.every(function (v) { return v && v.a; });
      var pct = pctFor(qty);
      var p = priced(items, pct);
      steps.forEach(function (s) {
        var on = parseInt(s.getAttribute('data-qty'), 10) === qty;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (qty > 1) {
        sumEl.innerHTML = '<strong>' + money(p.total) + '</strong>' + (p.off > 0 ? ' <s>' + money(p.full) + '</s> <span class="ladder__save">' + fill(cfg.strings.youSave, { amount: money(p.off) }) + '</span>' : '');
        sumEl.hidden = false;
        if (teaser) teaser.hidden = true;
        if (button) {
          button.disabled = !ok;
          if (buttonLabel) buttonLabel.textContent = ok ? fill(cfg.strings.addN, { n: qty }) + ' · ' + money(p.total) : textSoldOut;
        }
      } else {
        sumEl.hidden = true;
        if (teaser) teaser.hidden = false;
        /* Back to one stuk: give the button back what theme.js would show; otherwise theme.js owns it. */
        if (button && lastQty > 1) {
          var avail = !!(main && main.a);
          button.disabled = !avail;
          if (buttonLabel) buttonLabel.textContent = avail ? textAdd : textSoldOut;
        }
      }
      lastQty = qty;
    }

    steps.forEach(function (s) {
      s.addEventListener('click', function () {
        qty = parseInt(s.getAttribute('data-qty'), 10) || 1;
        buildRows();
        update();
      });
    });
    rowsEl.addEventListener('change', function (e) {
      var row = e.target.closest('.ladder__row');
      if (row) markRow(row);
      update();
    });
    /* A new colour or size above changes item 1, and for rows without their own colour choice also what they can be. */
    root.addEventListener('change', function (e) {
      if (!e.target.closest || !e.target.closest('[data-option-index]')) return;
      $$('.ladder__row', rowsEl).forEach(markRow);
      update();
    });

    /* On add: all stuks as items[] in the same form theme.js submits; the single id is left out for that one request. */
    form.addEventListener('submit', function () {
      $$('input[data-ladder-item]', form).forEach(function (i) { i.parentNode.removeChild(i); });
      if (qty < 2) return;
      var items = [find(checked())].concat($$('.ladder__row', rowsEl).map(rowVariant));
      var counts = {};
      var order = [];
      items.forEach(function (v) {
        if (!v) return;
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id] += 1;
      });
      order.forEach(function (id) {
        [['items[][id]', id], ['items[][quantity]', counts[id]]].forEach(function (pair) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = pair[0];
          input.value = pair[1];
          input.setAttribute('data-ladder-item', '');
          form.appendChild(input);
        });
      });
      idInput.disabled = true;
      setTimeout(function () {
        idInput.disabled = false;
        $$('input[data-ladder-item]', form).forEach(function (i) { i.parentNode.removeChild(i); });
      }, 0);
    });

    update();
  });
})();
